module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Simple-Line-Icons.ttf
// module id = 286
// module chunks = 0